/** Дефолтные иконки показателей отделения */
export const DEPARTMENT_STAT_ICON_SRC = {
  bed: '/images/department-icons/bed.png',
  clock: '/images/department-icons/clock.png',
  equipment: '/images/department-icons/equipment.png',
  team: '/images/department-icons/team.png',
}

export function departmentStatIconSrc(stat) {
  if (!stat) return ''
  const custom = String(stat.iconImage || '').trim()
  if (custom) return custom
  const key = String(stat.icon || '').trim()
  if (!key) return ''
  // URL или путь к загруженному файлу в поле icon (legacy/ручной ввод)
  if (key.startsWith('http://') || key.startsWith('https://') || key.startsWith('/')) {
    return key
  }
  return DEPARTMENT_STAT_ICON_SRC[key.toLowerCase()] || ''
}
